module.exports = __webpack_public_path__ + "static/media/photo35.4fb3a2a8.jpg";